export default "__VITE_ASSET__pbIlE89g__"